import { Instagram, Linkedin, Mail } from 'lucide-react';

import { content } from '../../data';

import "./Contact.css";

const Contact = ({ lang }) => {
  const t = content[lang].contact;

  return (
    <section id="contact" className="contact-section">
      <div className="contact-top">
        <span>{t.top}</span>
      </div>
      <div className="contact-center">
        <a href="mailto:jwawrzyniak.contact@gmail.com">jwawrzyniak.contact@gmail.com</a>
      </div>
      <div className="contact-bottom">
        <div className="socials">
          <a href="https://instagram.com/jwawrzyniak_graphic" target='_blank' rel="noreferrer"><Instagram size={20 }/></a>
          <a href="https://linkedin.com/in/jacwawrzyniak" target='_blank' rel="noreferrer"><Linkedin size={20} /></a>
          <a href="mailto:jwawrzyniak.contact@gmail.com"><Mail size={20} /></a>
        </div>
        <span>© 2026 Jakub Wawrzyniak</span>
      </div>
    </section>
  );
};

export default Contact;